import { createSlice } from "@reduxjs/toolkit";

export const professionalSlice = createSlice({
  name: "professional",
  initialState: {
    value: {
      hospitalName: "University Hospital of Derby and Burton",
      departmentName: "Example departmentName",
      name: "Example name",
      title: "Example title",
      profession: "Example profession",
      registrationNo: "Example registration No",
      id: "0",
      email: "ex@enrichmycare.com",
      phoneNumber: "0",
    },
  },
  reducers: {
    loggedIn: (state, action) => {
      state.value = action.payload; //payload contains the new values
    },
  },
});

export const { loggedIn } = professionalSlice.actions;

export default professionalSlice.reducer;
